module.exports = __webpack_public_path__ + "img/new_bg_img.e0664f18.svg";